// extracted by mini-css-extract-plugin
export default {"wrapper":"BlueSection_wrapper__fha9S","icon":"BlueSection_icon__zliZ6","title":"BlueSection_title__99xhe","text":"BlueSection_text__LrHfq"};